<div class="flex w-fit cursor-pointer items-center gap-1 rounded-full bg-neutral-100 pl-1 pr-1.5 text-neutral-500 hover:bg-neutral-200 hover:text-neutral-600">
  <ng-content select="[icon]"></ng-content>
  <ng-content select="[text]"></ng-content>
</div>
